import React, {useRef} from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate, useSearchParams} from 'react-router-dom';
import './PinCodeSetUp.css';
import PinInputElement from "../../components/PinInputElement";

const SetPinCodePage = () => {
  const {t} = useTranslation();
  const [pin, setPin] = React.useState(['', '', '', '']);
  const [error, setError] = React.useState('');
  const [searchParams] = useSearchParams();
  const [email, setEmail] = React.useState<string>('');
  const inputsRef = [useRef(null), useRef(null), useRef(null), useRef(null)];
  const navigate = useNavigate();

  React.useEffect(() => {
    const emailParam = searchParams.get('email') || '';
    console.log("emeis params ", emailParam)
    setEmail(emailParam);
  }, [searchParams]);

  const handleChange = (idx: number, value: string) => {
    if (!/^[0-9]?$/.test(value)) return;
    const newPin = [...pin];
    newPin[idx] = value;
    setPin(newPin);
    setError('');
    if (value && idx < 3) {
      // @ts-ignore
      inputsRef[idx + 1].current?.focus();
    }
  };


  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (pin.some(d => d === '')) {
      setError(t('pin.error_length'));
      return;
    }
    navigate('/confirm-pin', {state: {pin: pin.join(''), email}});
  };

  return (
    <div className="pin-setup-container">
      <div className="pin-setup-icon">
        <img src="/images/key-round.png" alt="Key icon" width={96} height={96} style={{display: 'block'}}/>
      </div>
      <h2 className="pin-setup-title">{t('pin.title_strong') || t('pin.title')}</h2>
      <div className="pin-setup-instructions">
        <div>{t('pin.instructions_line1')}</div>
        <div>{t('pin.instructions_line2')}</div>
      </div>
      <form className="pin-setup-form" onSubmit={handleSubmit} autoComplete="off">
        <div className="pin-setup-inputs">
          <PinInputElement
            stage="new"
            values={pin}
            onChange={(idx, val) => handleChange(idx, val)}
            borderType="default"
          />
        </div>
        {error && <div className="pin-setup-error">{error}</div>}
        <button
          type="submit"
          className="pin-setup-continue"
          disabled={pin.some(d => d === '')}
        >
          {t('pin.continue') || 'CONTINUE'}
        </button>
      </form>
    </div>
  );
};

export default SetPinCodePage;
